(() => {
  const bag = document.querySelector('[data-shf-bag]');
  if (!bag || typeof subscribe !== 'function') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => {
    const count = cartData?.item_count;
    if (!Number.isInteger(count)) return;
    bag.textContent = `Bag (${count})`;
    bag.setAttribute('aria-label', `Bag, ${count} items`);
  });
})();
